function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0v75h43.75L75 56.25V0H12.5z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.25 56.25V75L75 56.25H56.25z",
  fill: "#ABABAB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 75h18.75V56.25L37.5 75z",
  fill: "#DEDEDD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 18.75v21.875h50V18.75H0z",
  fill: "#71A742"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.11 32.656c0 1.425-.332 2.44-.994 3.05-.663.603-1.675.91-3.038.91-.715 0-1.297-.097-1.756-.294-.456-.194-.819-.466-1.088-.825a3.072 3.072 0 01-.55-1.247 7.035 7.035 0 01-.153-1.5v-.585h2.475v.416c0 .712.078 1.237.235 1.584.156.341.478.516.968.516.485 0 .81-.175.966-.516.156-.343.234-.871.234-1.584v-9.566h2.7v9.641zM22.469 23.015c.687 0 1.262.12 1.734.35.472.232.847.535 1.134.91.288.375.494.803.62 1.284.121.478.187.972.187 1.472 0 .688-.103 1.288-.31 1.8a3.231 3.231 0 01-.862 1.253 3.569 3.569 0 01-1.34.731 5.886 5.886 0 01-1.748.244h-1.44v5.344h-2.7V23.015h4.725zm-.825 6.066c.537 0 .975-.166 1.303-.49.331-.326.497-.832.497-1.52 0-.674-.144-1.187-.432-1.537-.287-.347-.768-.525-1.443-.525h-1.125v4.072h1.2zM35.21 26.228a2.502 2.502 0 00-.273-.722 1.815 1.815 0 00-.474-.544 1.157 1.157 0 00-.707-.215c-.65 0-1.115.362-1.406 1.09-.288.722-.431 1.925-.431 3.597 0 .803.025 1.525.075 2.175.05.65.14 1.203.272 1.66.13.456.318.806.562 1.05.244.243.56.365.947.365.166 0 .34-.047.538-.131.193-.088.371-.219.543-.394.169-.178.31-.397.422-.665.113-.27.169-.588.169-.95v-1.37h-1.778v-1.987h4.365v7.22h-1.987v-1.238h-.038c-.325.528-.715.896-1.172 1.115-.456.219-1.003.328-1.64.328-.825 0-1.497-.147-2.019-.434-.522-.288-.925-.728-1.219-1.331-.293-.603-.49-1.34-.587-2.222-.1-.881-.153-1.903-.153-3.066 0-1.122.072-2.112.215-2.96.144-.85.391-1.559.741-2.13a3.397 3.397 0 011.384-1.285c.579-.287 1.294-.431 2.157-.431 1.475 0 2.537.366 3.187 1.1.65.728.975 1.775.975 3.14h-2.587a3.457 3.457 0 00-.082-.765z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 21.351,
  y1: 15.104,
  x2: 103.926,
  y2: 97.669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFEEEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEDD"
})));

var SvgJpg = function SvgJpg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJpg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jpg.f5fc023e.svg";
export { ForwardRef as ReactComponent };